export default "__VITE_ASSET__44a3ad75__"